import React from 'react'
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from '@fortawesome/free-solid-svg-icons'
import CSSModules from 'react-css-modules'
import styles from './style.module.scss'

const ClientMenu: React.FC = CSSModules<React.FC>(() => {
  const toggleSubmenu: React.MouseEventHandler<HTMLElement> = (event) => {
    event.preventDefault()

    const list = event.currentTarget.parentElement
    if (list.classList.contains('open')) {
      list.classList.remove('open')
    }
    else {
      list.classList.add('open')
    }
  }

  return (
    <nav className='sidebar' styleName='client-menu'>
      <ul className='nav flex-column'>
        <li className='nav-item'>
          <a className='nav-open' onClick={toggleSubmenu}><FontAwesomeIcon icon={faAngleRight} /></a>
          <NavLink className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')} end to='/clients/home'>ホーム</NavLink>
        </li>
        <li className='nav-item has-children'>
          <a className='nav-open' onClick={toggleSubmenu}><FontAwesomeIcon icon={faAngleRight} /></a>
          <NavLink className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')} to='/clients/questionnaires'>契約更新の確認</NavLink>
        </li>
        <li className='nav-item has-children'>
          <a className='nav-open' onClick={toggleSubmenu}><FontAwesomeIcon icon={faAngleRight} /></a>
          <NavLink className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')} to='/clients/monthly_work_reports'>作業報告書一覧</NavLink>
        </li>
      </ul>
    </nav>
  )
}, styles)

export default ClientMenu
